import { Form, Input } from "@renderbus/ui";
import { FormInstance } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export function ExportBillForm({
  form,
  defaultExportName,
}: {
  form: FormInstance;
  defaultExportName?: string;
}) {
  const { t } = useTranslation("center");
  useEffect(() => {
    form.setFieldsValue({
      exportName: defaultExportName ? defaultExportName : "",
    });
  }, [form, defaultExportName]);

  return (
    <Form form={form}>
      <Form.Item
        label={t("user_export_filename")}
        name={"exportName"}
        required
        rules={[
          {
            required: true,
            message:
              t("analysis_scene_setting_input_required", {
                name: t("user_export_filename"),
              }) || "",
          },
        ]}
      >
        <Input suffix={".xls"} className="background-2C2C31" maxLength={50} />
      </Form.Item>
    </Form>
  );
}
